import React from 'react';
import { Button, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import './notfound.css'

export const NotFound = () => {
    const navigate = useNavigate();
    return (
        <Container className='vh-100'>
            <Row className="h-100 justify-content-center align-items-center">
                <div className="col-sm-12 text-center">
                    <div>
                        <h1 className="text-center">4 0 4</h1>
                    </div>
                    <div className='notfound_img'>
                        <img src="../../assets/images/notfound.gif" />
                    </div>
                    <div className='notfound_info position-relative'>
                        <h2>Look like you're lost</h2>
                        <p className='my-3'>the page you are looking for not avaible!</p>
                        <Button onClick={() => navigate("/dashboard")}>Go to Home</Button>
                    </div>
                </div>
            </Row>
        </Container>
    )
}

export default NotFound